import * as React from 'react';

import { cn } from '@/lib/utils';

export interface TextareaProps extends React.TextareaHTMLAttributes<HTMLTextAreaElement> {
  error?: boolean;
}

const Textarea = React.forwardRef<HTMLTextAreaElement, TextareaProps>(({ className, error, disabled, ...props }, ref) => {
  return (
    <textarea
      className={cn(
        'border-grey-3 placeholder:text-grey-5 focus-visible:border-default-blue disabled:bg-grey-1 disabled:text-default-text flex w-full gap-2 rounded border-2 p-2 text-sm focus-visible:outline-none disabled:cursor-not-allowed',
        error && '!border-default-red',
        className,
      )}
      ref={ref}
      disabled={disabled}
      {...props}
    />
  );
});
Textarea.displayName = 'Textarea';

export { Textarea };
